<div class="reset-container">
  <div class="reset-card">
    <div class="home-navigation">
      <button mat-button routerLink="/login" class="home-link">
        <mat-icon>chevron_left</mat-icon>
        Back to Login
      </button>
    </div>

    <div *ngIf="invalidToken && !success" class="invalid-message">
      <mat-icon>link_off</mat-icon>
      <h2>Link invalid or expired</h2>
      <p>This password reset link is invalid or has expired. Please request a new one.</p>
      <button mat-raised-button color="primary" routerLink="/forgot-password">Request new link</button>
    </div>

    <div *ngIf="!invalidToken && !success" class="reset-header">
      <h1>Set new password</h1>
      <p>Enter your new password below. It must be at least 8 characters with uppercase, lowercase, and a number.</p>
    </div>

    <div *ngIf="!invalidToken && !success" class="reset-form">
      <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>New password</mat-label>
          <input matInput type="password" formControlName="new_password" placeholder="Enter new password" />
          <mat-error *ngIf="form.get('new_password')?.touched && form.get('new_password')?.invalid">
            {{ getErrorMessage('new_password') }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Confirm password</mat-label>
          <input matInput type="password" formControlName="confirm_password" placeholder="Confirm new password" />
          <mat-error *ngIf="form.get('confirm_password')?.touched && form.get('confirm_password')?.invalid">
            {{ getErrorMessage('confirm_password') }}
          </mat-error>
        </mat-form-field>

        <button mat-raised-button color="primary" type="submit" class="full-width submit-button"
          [disabled]="form.invalid || isLoading">
          <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
          <span *ngIf="!isLoading">{{ isLoading ? 'Updating...' : 'Update password' }}</span>
        </button>
      </form>
    </div>

    <div *ngIf="success" class="success-message">
      <mat-icon>check_circle</mat-icon>
      <p>Password updated successfully. Redirecting to login...</p>
    </div>
  </div>
</div>
